import styled from "@emotion/styled";
import {Stack} from "@mui/material";
import {css} from "@mui/material/styles";
import isPropValid from "@emotion/is-prop-valid";

export const PlayerStatsWrapper = styled(Stack)`
	gap: 4px;
	justify-content: center;
	align-items: center;
	padding-bottom: 10px;
	position: relative;
	width: 100%;
	text-align: center;

	& > img {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: -1;
		opacity: 0.4;
		mix-blend-mode: multiply;
	}
`;

export const ImageWrapp = styled.div`
	--statsImageSize: 90px;
	min-height: var(--statsImageSize, 68px);
	position: relative;
	width: 100%;
	& > div:not(.animation) {
		position: absolute;
		top: -10px;
		left: 50%;
		transform: translateX(-50%) scale(1);
		height: 100%;
		z-index: 0;
		display: flex;
		justify-content: center;
		align-items: flex-start;

		img {
			&:nth-of-type(1),
			&:nth-of-type(7) {
				width: 13px;
				transform: translateY(68px) rotate(var(--rotate, 0deg));
			}

			&:nth-of-type(2),
			&:nth-of-type(6) {
				width: 16px;
				transform: translateY(40px) rotate(var(--rotate, 0deg));
			}

			&:nth-of-type(3),
			&:nth-of-type(5) {
				width: 24px;
				transform: translateY(17px) rotate(var(--rotate, 0deg));
				margin: 0 9px;
			}

			&:nth-of-type(4) {
				width: 57px;
				opacity: 0;
				visibility: hidden;
				transform: rotate(var(--rotate, 0deg));
			}
		}
	}
	& > img {
		width: var(--statsImageSize, 68px);
		margin: 0 auto;
		display: block;
		position: relative;
		z-index: 1;
	}
`;

export const Stats = styled(Stack)`
	padding-top: 8px;
	align-items: center;
	gap: 8px;
	border-top: 1px solid var(--Text-Text-Light, #fff);
	text-align: center;
`;

export const MainStats = styled(Stack)`
	flex-flow: row;
	gap: 16px;
	text-transform: none;
	text-align: center;
`;

export const Points = styled(Stack, {
	shouldForwardProp: isPropValid,
})<{hasMultiplier?: boolean}>`
	border-radius: 8px;
	padding: 4px 8px;
	h1 {
		line-height: 0.95;
	}
	${(props) =>
		props.hasMultiplier &&
		css`
			background: var(--color3);
			color: #000;
		`}
`;

export const SnowAnimationPosition = styled.div`
	position: absolute;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
	height: 150px;
	width: 100%;
	overflow: hidden;
	pointer-events: none;
	z-index: 1;

	& > div {
		height: 200%;
	}
`;
